import { Button, PaginatedBanner } from "@alpacahq/ui/old";

import { Card, Page } from "~/v2/components";
import { AccountStatusBanner } from "~/v2/components/AccountStatusBanner";
import { OrderTicket } from "~/v2/components/orderTicket";
import { APIKeys } from "./APIKeys";
import { Orders, Portfolio } from "./cards";
import { IRAContributionCard } from "./cards/IRAContributionCard";
import { ProgramsContainer } from "./cards/ProgramsContainer";
import { Watchlist } from "./cards/watchlist";
import { FpslSuccessModal } from "./FpslSuccessModal";
import { GoogleColab } from "./GoogleColab";
import type { useHomeController } from "./Home.controller";
import { HomeCarousel } from "./HomeCarousel/HomeCarousel.connector";
import { OpraAgreementModal } from "./OpraAgreementModal/OpraAgreementModal.connector";
import { Chart } from "./sections/chart";

export type HomePresentationProps = ReturnType<typeof useHomeController>;

export const HomePresentation = ({
  statusBannerAccount,
  refetchLiveAccounts,
  acatsBannerItems,
  margin,
  isMarginLoading,
  currentAccount,
  showIRAContributionCard,
  onBalancesClick,
  onInterestPaidClick,
  onViewAllOrders,
}: HomePresentationProps) => (
  <>
    <Page className="grid grid-cols-1 gap-4 space-y-0 p-8 pt-0 xs:pl-0 md:p-8 md:pt-0 md:pl-0 lg:grid-cols-3 lg:gap-6">
      <div className="flex flex-col gap-6 lg:col-span-2">
        {statusBannerAccount && (
          <AccountStatusBanner
            account={statusBannerAccount}
            refetchAccounts={refetchLiveAccounts}
          />
        )}
        {acatsBannerItems.length > 0 && (
          <PaginatedBanner
            items={acatsBannerItems}
            autoTransition={true}
            transitionInterval={15000}
          />
        )}
        <Chart margin={margin} isMarginLoading={isMarginLoading} />
        {currentAccount && (
          <ProgramsContainer
            account={currentAccount}
            margin={margin}
            isMarginLoading={isMarginLoading}
            onBalancesClick={onBalancesClick}
            onInterestPaidClick={onInterestPaidClick}
          />
        )}
        {showIRAContributionCard && <IRAContributionCard />}
        <Card title="Top Positions">
          <Portfolio />
        </Card>
        <Card
          title="Recent Orders"
          tools={
            <Button variant="ghost" onClick={onViewAllOrders}>
              View All
            </Button>
          }
        >
          <Orders />
        </Card>
      </div>
      <div className="flex w-full flex-col gap-6 lg:max-w-[511px]">
        <HomeCarousel margin={margin} />
        <OrderTicket />
        <GoogleColab />
        <APIKeys />
        <Watchlist />
      </div>
    </Page>
    <OpraAgreementModal />
    <FpslSuccessModal />
  </>
);
